import {
  GET_ALL_REPORT,
  GET_REPORT_STATS,
  REMOVE_REPORT_STATS,
  GET_REPORT_BY_ID,
  GET_ALL_CANDIDATE,
  GET_ALL_BOUSER_CANDIDATE,
  GET_ALL_CUSTOMER_CANDIDATE,
  REMEMBER_INFO,
  REMOVE_ALL_PROMOTION_REPORT,
  REMOVE_PROMOTION_REPORT,
  REMOVE_ALL_CANDIDATE,
  GET_PROMO_REPORT,
  REMOVE_PROMO_REPORT,
  GET_PROMO_ORDERS,
  REMOVE_PROMO_ORDERS,
} from '../actions/actionTypes';

const initialState = {
  reports: { loaded: false, data: [] },
  report: { loaded: false, data: [] },
  rememberedData: { loaded: false, data: {} },
  candidates: { loaded: false, data: [] },
  boUsers: { loaded: false, data: [] },
  customers: { loaded: false, data: [] },
  stats: { loaded: false, data: [] },
  promoReport: { loaded: false, data: {} },
  promoOrders: { loaded: false, data: [] },
};

const promotionReportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ALL_REPORT:
      return { ...state, reports: { loaded: true, data: payload } };
    case GET_REPORT_STATS:
      return { ...state, stats: { loaded: true, data: payload } };
    case GET_REPORT_BY_ID:
      return { ...state, report: { loaded: true, data: payload } };
    case GET_ALL_CANDIDATE:
      return { ...state, candidates: { loaded: true, data: payload } };
    case GET_ALL_BOUSER_CANDIDATE:
      return { ...state, boUsers: { loaded: true, data: payload } };
    case GET_ALL_CUSTOMER_CANDIDATE:
      return { ...state, customers: { loaded: true, data: payload } };
    case REMEMBER_INFO:
      return { ...state, rememberedData: { loaded: true, data: payload } };

    case REMOVE_ALL_PROMOTION_REPORT:
      return { ...state, reports: { loaded: false, data: [] } };
    case REMOVE_REPORT_STATS:
      return { ...state, stats: { loaded: false, data: [] } };
    case REMOVE_PROMOTION_REPORT:
      return { ...state, report: { loaded: false, data: [] } };
    case REMOVE_ALL_CANDIDATE:
      return {
        ...state,
        boUsers: { loaded: false, data: [] },
        customers: { loaded: false, data: [] },
      };
    case GET_PROMO_REPORT:
      return { ...state, promoReport: { loaded: true, data: payload } };
    case REMOVE_PROMO_REPORT:
      return { ...state, promoReport: { loaded: false, data: {} } };
    case GET_PROMO_ORDERS:
      return { ...state, promoOrders: { loaded: true, data: payload } };
    case REMOVE_PROMO_ORDERS:
      return { ...state, promoOrders: { loaded: false, data: [] } };
    default:
      return state;
  }
};

export default promotionReportReducer;
